module.exports = __webpack_public_path__ + "static/media/IG3IS _ icon green.8c27a0b5.png";